import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ServiceAdvisorComponent } from './service-advisor.component';


const routes: Routes = [
    {
        path: '',
        component: ServiceAdvisorComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServiceAdvisorRoutingModule { }
